import type { GuitarTrackAnalysis, ToneScene } from '../../models/toneAnalysis'
import { formatDuration, formatTimeSpan, getAnalysisDuration, getTimelinePosition } from '../../utils/toneAnalysisFormat'

type ToneTimelineProps = {
  tracks: GuitarTrackAnalysis[]
  toneScenes: ToneScene[]
}

export function ToneTimeline({ tracks, toneScenes }: ToneTimelineProps) {
  const totalDuration = getAnalysisDuration(tracks)

  return <div className="ts-analysis-timeline" aria-label="Tone analysis timeline">
    <div className="ts-analysis-timeline-scale">
      <span>0:00</span>
      <span>{formatTimeSpan(`00:${Math.floor(totalDuration / 60).toString().padStart(2, '0')}:${Math.floor(totalDuration % 60).toString().padStart(2, '0')}`)}</span>
    </div>
    {tracks.map((track) => <div className="ts-analysis-timeline-row" key={track.id}>
      <b>{track.role}</b>
      <div>
        {track.sections.map((section) => {
          const scene = toneScenes.find((toneScene) => toneScene.id === section.toneSceneId)
          const position = getTimelinePosition(section.start, section.end, totalDuration)

          return <span
            className="ts-analysis-timeline-segment"
            key={section.id}
            style={position}
            title={`${section.musicalSection ?? 'Section'} ${formatTimeSpan(section.start)}-${formatTimeSpan(section.end)}`}
          >
            {section.musicalSection ?? scene?.suggestedName ?? 'Tone'} - {formatDuration(section.start, section.end)}
          </span>
        })}
      </div>
    </div>)}
  </div>
}
